module.exports = __webpack_public_path__ + "static/media/faturarGTO.5aaa1ee7.svg";